import QuestionnaireModule from './QuestionnaireModule/QuestionnaireModule';

export default function CandidateQuestionnaireModulePage() {
  return (
    <main className="container">
      <QuestionnaireModule />
    </main>
  );
}
